import { MDBBtn, MDBChip, MDBIcon } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
//import AddRemoveNumbers from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import AddNumbersStatic from "../../../views/popups/phonenumbers/AddNumbersStatic";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import {
  formattedNumber,
  unFormatNumber,
} from "../../../views/popups/phonenumbers/AddRemoveNumbers";

// let redercount = 0;
const ConferenceBridge = ({
  register,
  errors,
  setValue,
  confPhoneNum,
  getValues,
  setError,
  clearErrors,
  watch,
}) => {
  const { t, i18n } = useTranslation();
  //const [error, setError] = useState({});
  const [AddNumbers, setAddNumbers] = useState(false);
  const [removePHNum, setRemovePHNum] = useState([]);
  const [addPHNum, setAddPHNum] = useState([]);
  const [grpaddednumbers, setGrpAddedNumbers] = useState([]);
  const [finaladdlist, setFinalAddList] = useState([]);
  const [finalremovedlist, setFinalRemovedList] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(true);
  const [confPhoneNums, setConfPhoneNums] = useState([]);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  const [isConferenceBridge, setIsConferenceBridge] = useState(false);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [sourceNumber, setSourceNumber] = useState([]);
  const [checkAvailbilty, setCheckAvailbilty] = useState(false);
  const [extensionFlag, setExtensionFlag] = useState(true);
  const [defaultExtension, setDefaultExtension] = useState(0);

  useEffect(() => {
    if (extensionFlag && getValues("conference.extension") != 0) {
      setDefaultExtension(getValues("conference.extension"));
      setExtensionFlag(false);
    }
  }, [extensionFlag, getValues("conference.extension")]);

  // redercount ++

  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      //navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    setSourceNumber(basicInfo.misc.free_dids);
  }

  useEffect(() => {
    if (
      (removePHNum.length > 0 || addPHNum.length > 0) &&
      !updateNumbersExecuted
    ) {
      updateAddedNumbers();
      setUpdateNumbersExecuted(true);
    }
  }, [addPHNum, removePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (confPhoneNum) {
      setConfPhoneNums(confPhoneNum);
      setAddPHNum(confPhoneNum);
      setGrpAddedNumbers(confPhoneNum);
    }
  }, [confPhoneNum]);

  function updateAddedNumbers() {
    const updatenum = addPHNum.filter(
      (number) => !grpaddednumbers.includes(number)
    );
    setFinalAddList(updatenum);
    setValue("conference.adddids", updatenum, { shouldDirty: true });
    setConfPhoneNums(addPHNum);
    setAddPHNum(addPHNum);
    const finalremoved = removePHNum.filter((num) =>
      grpaddednumbers.includes(num)
    );
    setFinalRemovedList(finalremoved);
    setValue("conference.removedids", finalremoved, { shouldDirty: true });
  }
  const handleDelete = (num) => {
    const number = unFormatNumber(num);
    const updateAddPHNum = addPHNum.filter((addNum) => addNum !== number);
    setConfPhoneNums(updateAddPHNum);
    setAddPHNum(updateAddPHNum);

    // Add the deleted number to removePHNum
    setRemovePHNum((prevRemovePHNum) => [...prevRemovePHNum, number]);
    // Filter out the removed number from grpaddednumbers and setFinalRemovedList
    let finalremoved = grpaddednumbers.filter((num) => num === number);

    const oldRemove = watch("conference.removedids");
    finalremoved = [...oldRemove, ...finalremoved];

    setFinalRemovedList(finalremoved);
    setValue("conference.removedids", finalremoved, { shouldDirty: true });
    const oldadd = watch("conference.adddids");
    const updatenum = oldadd.filter((num) => num !== number);
    setFinalAddList(updatenum);
    setValue("conference.adddids", updatenum, { shouldDirty: true });
  };

  const parseToInteger = (value, fieldname) => {
    if (value !== "") {
      setValue(fieldname, parseInt(value), { shouldDirty: true });
    }
  };
  const handleToggleChange = () => {
    const toggleid = document.getElementById("toggleCheckboxid");
    setValue("conf_flag", toggleid.checked ? true : false, {
      shouldDirty: true,
    });
  };

  async function checkAvailabilitys(e) {
    e.preventDefault();
    e.stopPropagation();
    // setextCheckFlag(1);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      //navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbilty(true);
      setError("conference.extension", { message: "Extension is available" });
    } else {
      setCheckAvailbilty(false);
      setError("conference.extension", {
        message: "Extension is not available",
      });
    }
    console.log(tdata);
  }

  useEffect(() => {
    if (getValues("conf_flag")) {
      setIsConferenceBridge(true);
    }
  }, [getValues("conf_flag")]);
  return (
    <>
      {/* <h1>{redercount}</h1> */}
      <div className="general-settings" id="ConferenceBridge">
        {t("ConferenceBridge")}
      </div>

      <div className="ps-0">
        <div className="add-numbermain">
          <div className="tel-numbers">{t("ConfBridge")}</div>
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                id="toggleCheckboxid"
                {...register("conf_flag")}
                onChange={() => {
                  setIsConferenceBridge((obj) => !obj);
                  handleToggleChange();
                }}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        {watch("conf_flag") && (
          <div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("name")}</div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <input
                    maxLength={35}
                    type="text"
                    {...register("conference.name", {
                      required: "Conference name is required",
                    })}
                    className="selectname w-100"
                  />
                  {errors.conference?.name && (
                    <p className="text-danger">
                      {errors.conference?.name.message}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">{t("extension")}</div>
              <div className="w-30">
                <input
                  type="text"
                  maxLength={5}
                  {...register("conference.extension", {
                    setValueAs: (value) => Number(value),
                    required: "Conference Extension is required",
                  })}
                  onChange={(e) => {
                    if (e.target.value !== "") {
                      if (
                        e.target.value.length >= 3 &&
                        e.target.value.length <= 5
                      ) {
                        // checkAvailabilitys(e);
                        if (
                          parseInt(defaultExtension) ===
                          parseInt(e.target.value)
                        ) {
                          clearErrors("conference.extension");
                        } else {
                          checkAvailabilitys(e);
                        }
                      }
                      setValue(
                        "conference.extension",
                        parseInt(e.target.value),
                        {
                          shouldDirty: true,
                        }
                      );
                    }
                  }}
                  className="selectname w-100"
                />
                {errors.conference?.extension && (
                  <>
                    {!checkAvailbilty && (
                      <>
                        <p className="text-danger">
                          {errors.conference?.extension.message}
                        </p>
                      </>
                    )}

                    {checkAvailbilty && (
                      <p style={{ color: "Green" }} className="clr-red">
                        {errors.conference?.extension.message}
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="add-numbermain py-2">
              <div className="tel-numbers">{t("telephone_Numbers")}</div>
              <MDBBtn
                className="m-2"
                onClick={(e) => {
                  e.preventDefault(); // Prevent the form submission
                  toggleShow12(); // Open the modal
                }}
              >
                <MDBIcon fas icon="plus" size="sm" />
                {t("add_Numbers")}
              </MDBBtn>
            </div>
            <div className="chips chips-placeholder">
              {confPhoneNums &&
                confPhoneNums.length > 0 &&
                confPhoneNums.map((phone) => (
                  <MDBChip
                    className="m-chip d-inline py-2 px-3"
                    label="Example label"
                    onDelete={handleDelete}
                    key={phone}
                    closeIcon
                    size="sm"
                  >
                    {formattedNumber(phone)}
                  </MDBChip>
                ))}
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("Pin")}</div>
              <div className="w-30">
                <input
                  type="text"
                  {...register("conference.pin", {
                    required: "Conference Pin is required",
                  })}
                  onBlur={(e) =>
                    parseToInteger(e.target.value, "conference.pin")
                  }
                  className="selectname w-100"
                />
                {errors.conference?.pin && (
                  <p className="text-danger text-left">
                    {errors.conference?.pin.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {AddNumbers && (
        <PopupLoader
          // size="lg"
          // className="modal-lg"
          title={"Add Numbers"}
          content={
            <AddNumbersStatic
              selectedNum={confPhoneNums}
              setaddPHNum={setAddPHNum}
              removePHNum={removePHNum}
              setRemovePHNum={setRemovePHNum}
              setUpdateNumbersExecuted={setUpdateNumbersExecuted}
              sourceNumber={sourceNumber}
              onClose={toggleShow12}
            />
          }
          onShow={setAddNumbers}
          onClose={toggleShow12}
        />
      )}
    </>
  );
};

export default ConferenceBridge;
